var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "detail-card",
    {
      attrs: {
        heading: _vm.otpHeading,
        subheading: _vm.otpSubHeading,
        isLoading: _vm.isLoading,
        isRedirecting: _vm.isRedirecting,
        isSubHeadingHtml: true,
        headingClass: _vm.headingClass,
      },
      scopedSlots: _vm._u(
        [
          _vm.flowName && _vm.flowName === "signUp"
            ? {
                key: "progress-stepper",
                fn: function () {
                  return [_c("progress-stepper")]
                },
                proxy: true,
              }
            : null,
        ],
        null,
        true
      ),
    },
    [
      _c(
        "div",
        {
          staticClass:
            "leo-flex leo-flex-col leo-gap-md leo-flex-grow leo-justify-between",
        },
        [
          _c(
            "div",
            { staticClass: "leo-flex leo-flex-col leo-gap-md leo-flex-grow" },
            [
              _vm.pageType === "email" && _vm.otpHint !== ""
                ? _c(
                    "div",
                    {
                      staticClass:
                        "leo-text-md leo-text-accent leo-text-center",
                    },
                    [_vm._v(" " + _vm._s(_vm.otpHint) + " ")]
                  )
                : _vm._e(),
              _c(
                "div",
                [
                  _c("leo-input-otp", {
                    ref: "inputOtp",
                    attrs: {
                      onChangeOTP: _vm.onChangeOTP,
                      mask: false,
                      error: _vm.isError,
                    },
                    on: {
                      onComplete: _vm.onComplete,
                      onBlur: _vm.onBlur,
                      onKeyUp: _vm.validateNumeric,
                      onFocus: _vm.onFocus,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "error",
                        fn: function () {
                          return [
                            _vm._v(" " + _vm._s(_vm.otpErrorMessage) + " "),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "leo-flex leo-flex-col leo-gap-md leo-pt-md",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "leo-text-md leo-text-accent" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.pageType === "mobile"
                                  ? _vm.otpProps.validMobileOtpLabel
                                  : _vm.otpProps.validEmailOtpLabel
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c("div", [
                        _c(
                          "div",
                          { staticClass: "leo-text-md leo-text-accent" },
                          [
                            _c(
                              "a",
                              _vm._g(
                                {
                                  class: _vm.isResendActionDisabled
                                    ? "leo-text-grey-350 leo-underline leo-cursor-not-allowed"
                                    : "leo-underline leo-text-primary leo-cursor-pointer",
                                },
                                !_vm.isResendActionDisabled
                                  ? { click: () => _vm.resetTimer() }
                                  : null
                              ),
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.pageType === "email" &&
                                        _vm.isDesktopChannel
                                        ? _vm.otpProps.MO.didNotOtpLabel
                                        : _vm.otpProps.didNotOtpLabel
                                    )
                                ),
                              ]
                            ),
                            _vm._v(" " + _vm._s(_vm.validOTPTimer) + " "),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm.pageType === "email" && _vm.isDesktopChannel
                ? _c(
                    "div",
                    { staticClass: "leo-flex mobileButtons leo-pt-xl" },
                    [
                      _c(
                        "leo-button",
                        {
                          attrs: {
                            primary: "",
                            block: "",
                            disabled: !_vm.complete,
                          },
                          on: { click: _vm.submitOtp },
                        },
                        [_vm._v("Continue")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.pageType === "email" && _vm.isDesktopChannel
                ? _c(
                    "div",
                    { staticClass: "leo-flex mobileButtons" },
                    [
                      _c(
                        "leo-button",
                        {
                          attrs: { text: "", block: "" },
                          on: { click: _vm.backAction },
                        },
                        [_vm._v("Cancel")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
          !_vm.isDesktopChannel
            ? _c(
                "div",
                { staticClass: "leo-flex leo-justify-between mobileButtons" },
                [
                  _c(
                    "leo-button",
                    {
                      attrs: { outline: "", block: "" },
                      on: { click: _vm.backAction },
                    },
                    [_vm._v("Back")]
                  ),
                  _c(
                    "leo-button",
                    {
                      staticClass: "leo-ml-md",
                      attrs: {
                        primary: "",
                        block: "",
                        disabled: !_vm.complete,
                      },
                      on: { click: _vm.submitOtp },
                    },
                    [_vm._v("Submit")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }